"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhoIsRegisteredKeeperOrLegalOwnerWidget = void 0;
var React = require("react");
var DriverKeeperPopupWidget_1 = require("../subscription/motor/DriverKeeperPopupWidget");
var commonFunctions_1 = require("../../commonFunctions");
var FalconQuestionWidgetBase_1 = require("../FalconQuestionWidgetBase");
var CollapseHtmlWithInfoIconWidget_1 = require("../../components/CollapseHtmlWithInfoIconWidget");
var journey_model_1 = require("@athena-portal/journey-model");
var WhoIsRegisteredKeeperOrLegalOwnerWidget = exports.WhoIsRegisteredKeeperOrLegalOwnerWidget = /** @class */ (function (_super) {
    __extends(WhoIsRegisteredKeeperOrLegalOwnerWidget, _super);
    function WhoIsRegisteredKeeperOrLegalOwnerWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.vehicleIndex = (0, commonFunctions_1.getIndexSetting)("vehicleIndex", _this.getSetting("vehicleIndex", undefined), _this.props.question.type);
        _this.otherVariants = new Map([
            [1, "Brother / Sister"],
            [2, "Child"],
            [3, "Common Law / Partner"],
            [4, "Company"],
            [5, "Lease Company"],
            [6, "Parent"],
            [7, "Other Relative"],
            [8, "Spouse / Civil Partner"],
            [9, "Other / Friend"]
        ]);
        _this.handleOnChangeEvent = function (event) {
            _this.props.onStateChange(_this.props.question.interactionField, event.target.value);
            _this.setState({
                registeredKeeperId: event.target.value,
                showConfirmation: false
            });
            _this.changelogRecorder.recordQuestion("change", _this.props);
        };
        _this.infoCallback = function (infoState) {
            _this.setState({ showInfo: infoState });
        };
        var registeredKeeper = _this.props.interaction.vehicles[_this.vehicleIndex].registeredKeeperId ?
            _this.props.interaction.vehicles[_this.vehicleIndex].registeredKeeperId : "";
        _this.state = {
            showInfo: false,
            registeredKeeperId: registeredKeeper,
            showConfirmation: false,
            redirect: false
        };
        return _this;
    }
    WhoIsRegisteredKeeperOrLegalOwnerWidget.prototype.renderInputField = function () {
        var _this = this;
        return (React.createElement("div", { className: this.state.showInfo ? "background-color-grey inner-content negative-margin" : "background-color-white" },
            React.createElement("div", { className: "media-body" }, this.renderHeader()),
            React.createElement(DriverKeeperPopupWidget_1.default, { show: this.state.showConfirmation, hide: function () { return _this.setState({ showConfirmation: false }); }, confirm: function () { return _this.props.engine.navigate("addDriver", false); }, title: "Registered keeper for this car", vehicleRegistrationNumber: "".concat(this.props.interaction.vehicles[this.vehicleIndex].registrationNumber), additionalDriversCount: this.props.interaction.additionalDrivers ? this.props.interaction.additionalDrivers.length : 0, driverFunction: "registered keeper" }),
            this.renderDrivers()));
    };
    WhoIsRegisteredKeeperOrLegalOwnerWidget.prototype.checkRegisteredKeeper = function (driverId) {
        var registeredKeeperId = this.props.interaction.vehicles[this.vehicleIndex].registeredKeeperId;
        if (!registeredKeeperId || registeredKeeperId === "") {
            return false;
        }
        return registeredKeeperId === driverId;
    };
    WhoIsRegisteredKeeperOrLegalOwnerWidget.prototype.renderHeader = function () {
        var contentElement = React.createElement("div", { className: "card shadow-none" },
            React.createElement("div", { className: "card-body" },
                React.createElement("p", { className: "card-text" }, this.renderHtml(this.getSetting("infoHtml")))));
        return (React.createElement("div", { className: "bathroom-collapse-label-widget" },
            React.createElement(CollapseHtmlWithInfoIconWidget_1.CollapseHtmlWithInfoIconWidget, { header: this.renderHtml(this.getSetting("labelHtml")), content: contentElement, parentCallback: this.infoCallback })));
    };
    WhoIsRegisteredKeeperOrLegalOwnerWidget.prototype.renderDrivers = function () {
        var vehicle = this.props.interaction.vehicles[this.vehicleIndex];
        var policyHolder = this.props.interaction.policyHolder;
        var vehicleInformation = "".concat(vehicle.make, " ").concat(vehicle.model, " ").concat(vehicle.registrationNumber);
        return (React.createElement("div", { className: "input-group margin-top-14", role: "group", "aria-label": "Who is registered keeper for ".concat((0, commonFunctions_1.trimParenthesesFromString)(vehicleInformation), "?") },
            React.createElement("select", { id: "registeredKeeper", className: "form-control ".concat(this.getInputValidationClass()), onChange: this.handleOnChangeEvent, onFocus: this.executeNativeEvent, onBlur: this.handleOnBlurEvent, onClick: this.executeNativeEvent, onDoubleClick: this.executeNativeEvent, value: this.bindFromField(this.props.question.interactionField) || "" },
                React.createElement("option", { disabled: true, value: "" }, "Please select..."),
                React.createElement("option", { value: 0 },
                    policyHolder.firstName,
                    " ",
                    policyHolder.lastName),
                React.createElement("option", { disabled: true, value: "" }, "\u2014\u2014\u2014\u2014\u2014\u2014"),
                this.renderOtherVariants(this.otherVariants))));
    };
    WhoIsRegisteredKeeperOrLegalOwnerWidget.prototype.renderOtherVariants = function (otherVariants) {
        var otherVariantsList = [];
        otherVariants.forEach(function (value, key) {
            return otherVariantsList.push(React.createElement("option", { value: key }, value));
        });
        return otherVariantsList;
    };
    WhoIsRegisteredKeeperOrLegalOwnerWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "labelHtml", type: journey_model_1.TypeDescriptions.String },
            { name: "infoHtml", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], WhoIsRegisteredKeeperOrLegalOwnerWidget);
    return WhoIsRegisteredKeeperOrLegalOwnerWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
//# sourceMappingURL=WhoIsRegisteredKeeperOrLegalOwnerWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/motorCommon/WhoIsRegisteredKeeperOrLegalOwnerWidget.js
// module id = 3446
// module chunks = 0